module.exports = __webpack_public_path__ + "img/calendar-checked-custom.a6d833dc.svg";